const $ = jQuery;

export function better_wpcf7_forms() {
  $( '.wpcf7 .wpcf7-submit' ).each( function ( this: HTMLButtonElement ) {
    // Move ajax loader before submit button
    $( this ).find( '+ .ajax-loader' ).insertBefore( this );
    // Change submit input to a button instead
    var submitHTML = this.outerHTML;
    var submitValue = this.value;
    submitHTML = submitHTML.replace( /^<input /, '<button ' );
    submitHTML = submitHTML.replace( /\/?>$/, '>' + submitValue + '</button>' );
    $( this ).replaceWith( submitHTML );
  } );
}
